import { Link } from 'react-router-dom';

export interface ToolsetSummary {
  slug: string; name: string; author: string; category: string; description: string; docsUrl: string;
  authType: 'none' | 'bearer' | 'header' | 'query'; needsCredential: boolean; writes: boolean; toolCount: number; installed: boolean;
}
export interface ToolsetParam { name: string; type?: string; description: string; required?: boolean }
export interface ToolsetTool {
  name: string; agentName: string; label: string; description: string; method: string; url: string; writes?: boolean; params: ToolsetParam[];
}
export interface ToolsetDetail extends ToolsetSummary {
  about: string;
  secret: { label: string; help: string } | null;
  inputs: Array<{ key: string; label: string; options?: string[]; default?: string }>;
  installedTools: Array<{ id: string; name: string }>;
  tools: ToolsetTool[];
}

/** Cor da inicial por categoria (quadrado do cartão, como o logo na lista de modelos da Cloudflare) */
const TONES: Record<string, string> = {
  Pagamentos: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  CRM: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
  Agendamento: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200',
  'E-commerce': 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  'Dados e pesquisa': 'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-200',
};

export function ToolsetLogo({ name, category, size = 40 }: { name: string; category: string; size?: number }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-lg font-semibold ${TONES[category] ?? 'bg-kumo-tint text-kumo-default'}`}
      style={{ width: size, height: size, fontSize: size * 0.42 }}
      aria-hidden
    >
      {name.slice(0, 1).toUpperCase()}
    </span>
  );
}

/** Abas das duas telas de ferramentas: Explorar (catálogo) e Minhas ferramentas (cadastro manual) */
export function ToolsTabs({ active }: { active: 'explorar' | 'minhas' }) {
  const cls = (on: boolean) => `border-b-2 px-1 pb-2 text-sm font-medium ${on ? 'border-kumo-brand text-kumo-default' : 'border-transparent text-kumo-subtle hover:text-kumo-default'}`;
  return (
    <nav className="mb-6 flex gap-6 border-b border-kumo-line" aria-label="Ferramentas">
      <Link to="/ia/ferramentas" className={cls(active === 'explorar')}>Explorar</Link>
      <Link to="/ia/ferramentas/minhas" className={cls(active === 'minhas')}>Minhas ferramentas</Link>
    </nav>
  );
}
